export const DEFAULT_METRICS_PERIOD_OPTIONS: readonly (number | null)[] = [
  7,
  15,
  30,
  90,
  null,
];
